export default function(word, amount) {
 return (amount > 1 || amount === 0) ? `${word}s` : word
}
